import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appWWWVToolTip]'
})
export class ToolTipDirective {
  @Input() content = '';
  @Input() tooltipHightOffset = 10;
  @Input() placement: 'top' | 'right' = 'top';
  tooltip = null;
  @Input() isShow = true;

  constructor(private element: ElementRef) {
    element.nativeElement.addEventListener('mouseenter', () => {
      if (this.isShow) {
        const tooltip = document.createElement('div');
        tooltip.classList.add('tooltip-show');
        tooltip.textContent = this.content;
        element.nativeElement.style.position = 'relative';
        element.nativeElement.append(tooltip);

        if (this.placement === 'right') {
          tooltip.classList.add('tooltip-placement-right');
          tooltip.style.top = '50%';
          tooltip.style.left = (element.nativeElement.offsetWidth + this.tooltipHightOffset) + 'px';
          tooltip.style.transform = 'translateY(-50%)';
        } else {
          const elWidthCenter = element.nativeElement.offsetWidth / 2;
          const left = elWidthCenter -  (tooltip.offsetWidth / 2);
          const top = - (tooltip.offsetHeight + this.tooltipHightOffset);
          tooltip.style.top = top + 'px';
          tooltip.style.left = left + 'px';
        }

        this.tooltip = tooltip;
      }
    });

    element.nativeElement.addEventListener('mouseleave', () => {
      if (this.tooltip) {
        this.tooltip.remove();
      }
    });
  }

}
